/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB, replacePXinStringWithEM, color, textShadow } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FIELD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	field: {
		backgroundColor: `rgba(0, 0, 0, 0.2)`,
		border: replacePXinStringWithEM(`1.5px dashed ${color.white}`),
		borderRadius: pxToEm(3),
		color: color.greyMedium,
		fontSize: pxToEm(14),
		width: '100%',
		// maxWidth: pxToEm(400),
		padding: replacePXinStringWithEM('6px 6px 7px 0px'),
		transition: 'background .2s linear 0s',
		overflow: 'hidden', // helps with button animation
		textAlign: 'right',
		height: pxToEm(50),
		'&:hover': {
			backgroundColor: `rgba(0, 0, 0, 0.4)`,
		},
		'&.button-true': { 
			'& input, select, button': { display: 'inline-block', verticalAlign: 'middle' },
			'& input, select': { width: replacePXinStringWithEM('calc(100% - 79px)') }, // 100% - (button size + margin left)
			'& button': { 
				// transform: 'translateX(-200%)',
				width: pxToEm(69), 
				marginLeft: pxToEm(10),
				// opacity: '0',
				// animationName: 'fadeInLeft',
    //             animationDelay: '.4s',
    //             animationDuration: '.3s',
    //             animationFillMode: 'forwards'
			}
		},
		'&.isValid-true': {
			fontSize: 'bold'
		},
		'&.isValid-false': {
			background: convertHexToRGB(color.red, 50)
		}
	}
};